export interface CitizenshipOption {
  value: string;
  labelKey: string;
}

export const KZ_CITIZENSHIP = "Казахстан";

export const CITIZENSHIP_OPTIONS: CitizenshipOption[] = [
  { value: KZ_CITIZENSHIP, labelKey: "kazakhstan" },
  { value: "Китай", labelKey: "china" },
  { value: "Индия", labelKey: "india" },
  { value: "США", labelKey: "usa" },
  { value: "Индонезия", labelKey: "indonesia" },
  { value: "Пакистан", labelKey: "pakistan" },
  { value: "Нигерия", labelKey: "nigeria" },
  { value: "Бразилия", labelKey: "brazil" },
  { value: "Бангладеш", labelKey: "bangladesh" },
  { value: "Россия", labelKey: "russia" },
  { value: "Мексика", labelKey: "mexico" },
  { value: "Япония", labelKey: "japan" },
  { value: "Эфиопия", labelKey: "ethiopia" },
  { value: "Филиппины", labelKey: "philippines" },
  { value: "Египет", labelKey: "egypt" },
  { value: "Вьетнам", labelKey: "vietnam" },
  { value: "ДР Конго", labelKey: "drc" },
  { value: "Иран", labelKey: "iran" },
  { value: "Турция", labelKey: "turkey" },
  { value: "Германия", labelKey: "germany" },
  { value: "Таиланд", labelKey: "thailand" },
  { value: "Великобритания", labelKey: "uk" },
  { value: "Танзания", labelKey: "tanzania" },
  { value: "Франция", labelKey: "france" },
  { value: "Южная Африка", labelKey: "south_africa" },
  { value: "Италия", labelKey: "italy" },
  { value: "Кения", labelKey: "kenya" },
  { value: "Мьянма", labelKey: "myanmar" },
  { value: "Колумбия", labelKey: "colombia" },
  { value: "Южная Корея", labelKey: "south_korea" },
  { value: "Испания", labelKey: "spain" },
  { value: "Уганда", labelKey: "uganda" },
  { value: "Аргентина", labelKey: "argentina" },
  { value: "Алжир", labelKey: "algeria" },
  { value: "Судан", labelKey: "sudan" },
  { value: "Украина", labelKey: "ukraine" },
  { value: "Ирак", labelKey: "iraq" },
  { value: "Афганистан", labelKey: "afghanistan" },
  { value: "Польша", labelKey: "poland" },
  { value: "Канада", labelKey: "canada" },
  { value: "Марокко", labelKey: "morocco" },
  { value: "Саудовская Аравия", labelKey: "saudi_arabia" },
  { value: "Узбекистан", labelKey: "uzbekistan" },
  { value: "Малайзия", labelKey: "malaysia" },
  { value: "Ангола", labelKey: "angola" },
  { value: "Мозамбик", labelKey: "mozambique" },
  { value: "Перу", labelKey: "peru" },
  { value: "Йемен", labelKey: "yemen" },
  { value: "Гана", labelKey: "ghana" },
  { value: "Непал", labelKey: "nepal" },
  { value: "Венесуэла", labelKey: "venezuela" },
  { value: "Кыргызстан", labelKey: "kyrgyzstan" },
  { value: "Таджикистан", labelKey: "tajikistan" },
  { value: "Туркменистан", labelKey: "turkmenistan" },
];

